/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
import React, { useState, useMemo, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { BsArrowUp } from "react-icons/bs";
import { useRouteMatch } from "react-router-dom";
import {
  Box,
  withStyles,
  Collapse,
  IconButton,
  Typography,
  Tooltip,
  makeStyles,
  Button,
} from "@material-ui/core";
import { RiCalendar2Line, RiMastercardLine } from "react-icons/ri";
import ScaleLoader from "react-spinners/ScaleLoader";
import {
  computeEstimationTotals,
  // applyCorrectionToEstimation,
  // removeCorrectionToEstimation,
  groupEstimationsDaily,
} from "lib/utils/estimations";
import getElasticities from "lib/requests/elasticities";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import LockIcon from "@material-ui/icons/Lock";
import athenaClient from "lib/axios/clients";
import { groupByPriceAndReduceEstimations } from "lib/filters/estimations";
import moment from "moment";
import {
  REACT_APP_BASE_URL,
  primaryColor,
  PriceOut,
} from "resources/constants";
import buildRequestUrl from "lib/requests/requestUtils";
import {
  filterDailyEstimationFieldsWithoutIdentifier,
  getEstimationsByCycle,
} from "lib/requests/estimations";
import useDidMountEffect from "lib/react/customHooks";
import _ from "lodash";
import {
  setScenarioEstimations,
  setSelectedScenario,
  setCacheReferenceScenario,
  setCacheScenario,
  setReferenceScenario,
  addScenarioTotals,
} from "app/scenarios/duck/slices";
import CardComponent from "app/common/CardComponent";
import SelectOptionsComponent from "app/common/SelectOptionsComponent";
import { handleScenarioType } from "lib/utils/scenarios";
import mixpanelTrack from "app/common/MixpanelComponent";
import {
  getFormattedCellValue,
  nFormatter,
  getROI,
  // getNestedObject,
} from "lib/utils";
import BadRequestDialog from "app/common/dialog/BadRequestDialog";
import EstimationCyclePromotionsChartComponent from "./EstimationCyclePromotionsChartComponent";
import EstimationDailyPromotionsChartComponent from "./EstimationDailyPromotionsChartComponent";
import InitialChartDailyPromotionsComponent from "./InitialChartDailyPromotionsComponent";
import DailyPromotionsComponent from "./DailyPromotionsComponent";

const useRowStyles = makeStyles((theme) => ({
  row: {
    display: "flex",
    justifyContent: "space-evenly",
    backgroundColor: "#fcfcfc",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "#ECEFF1",
    },
  },
  rowCell: {
    padding: "10px 5px 10px 5px",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    height: "60px",
    "&:first-child": {
      flexBasis: "50px",
      maxWidth: "50px",
      minWidth: "50px",
    },
    width: "145px",
    minWidth: "145px",
  },
  large: {
    wordBreak: "break-all",
    width: "145px",
    minWidth: "145px",
  },
  cellValue: {
    display: "-webkit-box",
    overflow: "hidden",
    textOverflow: "ellipsis",
    "-webkit-line-clamp": "2",
    "-webkit-box-orient": "vertical",
    [theme.breakpoints.up("xs")]: {
      fontSize: "0.750rem",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "0.750rem",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "0.750rem",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "0.800rem",
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "0.800rem",
    },
  },
  numeric: {
    alignItems: "flex-end",
  },
  expansionDetailsContainer: {
    // Height of the row render in EstimationComponent
    height: "280px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // padding: theme.spacing(2),
  },
  light: {
    color: "#9e9e9e",
  },
  cellPercentage: {
    marginLeft: "5px",
    display: "flex",
    alignItems: "center",
    fontSize: "12px",
  },
  darkGreyBackground: {
    backgroundColor: "rgba(221, 221, 221, 0.2)",
  },
  expandButton: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  titleCardContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: "60px",
    paddingTop: "10px",
  },
  titleHeader: {
    display: "flex",
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    // background: "yellow",
    alignSelf: "center",
    // paddingTop: "10px",
    marginBottom: "120px",
  },
  dailyCardTitleAnimation: {
    marginBottom: "0",
    animation: "$dailyCardTitleAnimation 100ms linear forwards",
  },
  "@keyframes dailyCardTitleAnimation": {
    "0%": {
      marginBottom: "120px",
    },
    "100%": {
      marginBottom: "0",
    },
  },
  cardTitleAnimation: {
    marginBottom: "120px",
    animation: "$cardTitleAnimation 100ms linear forwards",
  },
  "@keyframes cardTitleAnimation": {
    "0%": {
      marginBottom: "0",
    },
    "100%": {
      marginBottom: "120px",
    },
  },
  titleOffsetAnimation: {
    transform: "translate(0,0)",
    animation: "$titleOffsetAnimation 100ms linear forwards",
  },
  "@keyframes titleOffsetAnimation": {
    "0%": { transform: "translate(0,60px)" },
    "100%": { transform: "translate(0,0)" },
  },
  titleOffsetReverseAnimation: {
    transform: "translate(0,60px)",
    animation: "$titleOffsetReverseAnimation 100ms linear forwards",
  },
  "@keyframes titleOffsetReverseAnimation": {
    "0%": { transform: "translate(0,0)" },
    "100%": { transform: "translate(0,60px)" },
  },
  headerFirstTextDailyPromotions: {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "center",
    paddingTop: "10px",
  },
  containerSelectOptionsDailyPromotions: {
    marginRight: "20px",
  },
  CalendarCardContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginLeft: "7px",
    paddingTop: "6px",
    marginRight: "20px",
  },
  CalendarCardContainerDailyPromotions: {
    marginLeft: "20px",
  },
  titleCard: {
    fontWeight: "bold",
    fontSize: 22,
    color: "#666666",
    paddingRight: "5px",
  },
  tooltipContainer: { padding: "5px" },
  borderBarTop: {
    borderTop: "1px solid #e2e2e2",
    marginBottom: "5px",
    width: "95%",
    marginLeft: "32px",
  },
  icon: {
    width: "22px",
    height: "22px",
    color: "#999999",
  },
  iconDailyPromotions: {
    color: "gray",
  },
  iconMultibuy: {
    color: "##999999",
  },
  multibuyTextWithIcon: {
    display: "flex",
    alignItems: "center",
  },
  textContainerDailyPromotions: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    color: "#999999",
    paddingLeft: "5px",
    fontSize: "11px",
  },
  textCardContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: "5px",
    color: "#999999",
  },
  textOwnElasticity: {
    fontWeight: "bold",
  },
  itemContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
  },
  priceSliderContainer: {
    width: "10%",
    alignSelf: "center",
    marginBottom: "10px",
    marginRight: "5px",
  },
  priceSliderContainerTypeOne: {
    width: "90%",
  },
  priceSliderContainerTypeTwo: {
    width: "90%",
    marginRight: "5px",
  },
  priceSliderContainerTypeThree: {
    width: "90%",
  },
  textSlider: {
    alignSelf: "center",
    fontWeight: "bold",
    fontSize: 18,
    color: "#999999",
    display: "flex",
    justifyContent: "center",
    marginTop: "50px",
  },
  calendarContainerDailyPromotions: {
    marginLeft: "35px",
  },
  selectContainerEventType: {
    textAlign: "center",
    minWidth: "175px",
  },
  promotionButtonActive: {
    backgroundColor: "#DDDDDD",
  },
}));

export default function EstimationRowDailyPromotionsComponent({
  row,
  referenceRow,
  isReference,
  style,
  index,
  groupBy,
  setSelectedIndex,
  expandedRow,
  setExpandedRow,
  setDailyPromotion,
  dailyPromotion,
  isLoading,
  setIsLoading,
  isBlocked,
}) {
  const { url } = useRouteMatch();
  const isTpo = !url.includes("pricing");
  const labelTableColumns = ["product", "retailer", "area"];
  const numericTableColumns = isTpo
    ? ["price", "units", "sales", "margin", "units_in", "investment_in"]
    : ["price", "units", "sales", "margin", "units_in", "sales_in"];
  const classes = useRowStyles();
  const dispatch = useDispatch();
  const [currentTupleData, setCurrentTupleData] = useState(null);
  const [isSelectedDays, setIsSelectedDays] = useState(false);
  const [dailySelectedEstimations, setDailySelectedEstimations] = useState(
    null
  );
  const [dailyTotalWeight, setDailyTotalWeight] = useState(0);
  const [selectedPrice, setSelectedPrice] = useState();
  const [isPriceChange, setIsPriceChange] = useState(false);
  const scenariosSlice = useSelector((state) => state.scenarios);
  const metadataSlice = useSelector((state) => state.metadata);
  const deltaEventsCatalog = useSelector((state) => state.catalog.events);
  const [ownElasticity, setOwnElasticity] = useState(null);
  const [currentDeltaEvents, setCurrentDeltaEvents] = useState([]);
  const [calendarDays, setCalendarDays] = useState(null);
  const [isSelectedSameDays, setIsSelectedSameDays] = useState(false);
  const [multibuySlopeIntercept, setMultibuySlopeIntercept] = useState({});
  const configCatSlice = useSelector((state) => state.auth.configCatUser);
  const priceOutLabelByTenant = configCatSlice?.features.isUsaTerminology
    ? PriceOut
    : "Price Out";
  // We use this variable to avoid having to use the ternary expression inside useState everywhere we want to paint rowValues. To avoid extra requests to the server, every time an estimation changes we will update the value of selected estimation so we do not have to ask the server for the new value after the update
  const [rowValues, setRowValues] = useState(row);
  const [scenarioEstimationsDaily, setScenarioEstimationsDaily] = useState(
    null
  );
  const DEFAULT_PROMOTIONAL_EVENT = { key: null, label: "TPR" };
  const [currentPromotionalEvent, setCurrentPromotionalEvent] = React.useState(
    DEFAULT_PROMOTIONAL_EVENT
  );
  const [rowHasTypeEvent, setRowHasTypeEvent] = useState({
    key: null,
    label: "TPR",
  });
  const [isBadRequest, setIsBadRequest] = useState(false);
  const StyledTooltip = withStyles(() => ({
    tooltip: {
      backgroundColor: "gray",
    },
  }))(Tooltip);

  const StylePromotiondButton = withStyles(() => ({
    root: {
      minWidth: "0px",
      pading: "6px 4px",
      "&:hover": {
        backgroundColor: "#DDDDDD",
      },
    },
  }))(Button);

  const StyledButton = withStyles(() => ({
    root: {
      minWidth: "0px",
      "&:hover": {
        backgroundColor: "#FAFAFA",
      },
    },
  }))(Button);

  const handleDailyPromotions = () => {
    mixpanelTrack(`Click button Custom daily promotions`);
    setDailyPromotion(false);
    setIsSelectedDays(false);
  };

  const handleTpo = () => {
    mixpanelTrack(`Click button Custom daily promotions`);
    if (scenarioEstimationsDaily?.data) {
      setDailyPromotion(true);
    }
  };

  const textTitle = (title, phraseOne, phraseTwo, phraseThree, phraseFour) => (
    <div className={classes.tooltipContainer}>
      <div className={classes.tooltipTitle}>{title}</div>
      <div>{phraseOne}</div>
      <div>{phraseTwo}</div>
      <div>{phraseThree}</div>
      <div>{phraseFour}</div>
    </div>
  );

  const eventLabelHoverChart = (
    <>
      {rowHasTypeEvent.key !== null ? (
        <Box component="div" className={`${classes.multibuyTextWithIcon}`}>
          {rowHasTypeEvent.label}&ensp;
          <RiMastercardLine className={`${classes.icon}`} />
        </Box>
      ) : (
        <Box component="div" className={`${classes.tooltipTitle}`}>
          TPR
        </Box>
      )}
    </>
  );

  useEffect(() => {
    const uniqueDates = _.uniqBy(dailySelectedEstimations, "date");
    const datesFilteredEstimations = _.sortBy(
      _.map(uniqueDates, (estimation) => {
        return estimation.date;
      }),
      (date) => moment(date, "YYYY-MM-DD")
    );
    const daysSelected = _.sortBy(
      _.map(
        calendarDays,
        (date) => {
          return date.format("YYYY-MM-DD");
        },
        (date) => moment(date, "YYYY-MM-DD")
      )
    );
    if (_.isEqual(datesFilteredEstimations, daysSelected)) {
      setIsSelectedSameDays(true);
    } else {
      setIsSelectedSameDays(false);
    }
  }, [calendarDays]);

  useDidMountEffect(async () => {
    try {
      await setIsLoading(true);
      if (isPriceChange) {
        const estimationsForPrice = await getEstimationsByCycle({
          filters: {
            product: row.product,
            ...(row.retailer && { retailer: row.retailer }),
            ...(row.retailer_group && { retailer_group: row.retailer_group }),
            ...(row.area && { area: row.area }),
            cycle: { id: scenariosSlice.selectedScenario.scenario.cycle_id },
            data_source_id: 1,
            min_price: selectedPrice - 0.001,
            max_price: selectedPrice + 0.001,
            expand: "delta_events_by_cycle",
          },
        });

        let updatedScenarioEstimations = {};

        // For each tuple involved in the price change we want to find the current scenario estimation for that tuple and update it with the values for the new price
        const scenarioEstimationInEstimationDaily = [];
        _.forEach(estimationsForPrice.data, (estimation) => {
          const selectedEstimationsDaily = _.filter(
            !dailyPromotion
              ? scenarioEstimationsDaily.data
              : dailySelectedEstimations,
            {
              area_id: estimation.area_id,
              product_id: estimation.product_id,
              retailer_id: estimation.retailer_id,
            }
          );
          _.forEach(selectedEstimationsDaily, (dailyEstimation) => {
            const estimationDaily = _.cloneDeep(estimation);
            _.forEach(
              [
                "units",
                "units_in",
                "margin",
                "sales",
                "sales_in",
                "retailer_margin",
              ],
              (columnToUpdate) => {
                estimationDaily[columnToUpdate] =
                  estimation[columnToUpdate] * dailyEstimation.daily_weight +
                  (currentPromotionalEvent.key !== null &&
                  estimation.delta_events_by_cycle !== null
                    ? estimation.delta_events_by_cycle[
                        `delta_${columnToUpdate}`
                      ] * dailyEstimation.daily_weight
                    : 0);
              }
            );

            estimationDaily.id = dailyEstimation.id;
            estimationDaily.date = dailyEstimation.date;
            estimationDaily.daily_weight = dailyEstimation.daily_weight;
            estimationDaily.estimation_cycle_id = estimation.id;
            estimationDaily.event_id = currentPromotionalEvent.key;
            scenarioEstimationInEstimationDaily.push(estimationDaily);
          });
        });

        let scenarioEstimationsForGrouping = scenarioEstimationInEstimationDaily;

        setDailySelectedEstimations(scenarioEstimationInEstimationDaily);

        if (dailyPromotion) {
          scenarioEstimationsForGrouping = _.cloneDeep(
            scenarioEstimationsDaily.data
          );
          _.forEach(dailySelectedEstimations, (estimationDaily) => {
            _.remove(scenarioEstimationsForGrouping, {
              area_id: estimationDaily.area_id,
              product_id: estimationDaily.product_id,
              retailer_id: estimationDaily.retailer_id,
              date: estimationDaily.date,
            });
          });
          scenarioEstimationsForGrouping = scenarioEstimationsForGrouping.concat(
            scenarioEstimationInEstimationDaily
          );
        }

        setScenarioEstimationsDaily({
          data: _.sortBy(scenarioEstimationsForGrouping, (estimationDaily) =>
            moment(estimationDaily.date, "YYYY-MM-DD")
          ),
        });

        scenarioEstimationsForGrouping = _.map(
          scenarioEstimationsForGrouping,
          (scenarioEstimation) => {
            const selectedScenarioEstimation =
              scenariosSlice.selectedScenario.estimations[
                `${scenarioEstimation.product_id}-${scenarioEstimation.area_id}-${scenarioEstimation.retailer_id}`
              ];
            return {
              ...scenarioEstimation,
              product: selectedScenarioEstimation.product,
              retailer: selectedScenarioEstimation.retailer,
              area: selectedScenarioEstimation.area,
            };
          }
        );

        const groupedScenarioEstimationsDaily = _.groupBy(
          scenarioEstimationsForGrouping,
          (estimation) => {
            return `${estimation.product_id}-${estimation.area_id}-${estimation.retailer_id}`;
          }
        );

        updatedScenarioEstimations = groupEstimationsDaily(
          groupedScenarioEstimationsDaily,
          metadataSlice["custom-projection"],
          scenariosSlice.referenceScenario.estimations,
          configCatSlice?.features.newInvestmentCalculation
        );

        const keyToUpdate = `${rowValues.product_id}${
          row.area ? "-".concat(rowValues.area_id) : ""
        }${row.retailer ? "-".concat(rowValues.retailer_id) : ""}${
          row.retailer_group ? "-".concat(rowValues.retailer_group_id) : ""
        }`;

        const EstimationsUpdated = {
          estimations: {
            ...scenariosSlice.selectedScenario.estimations,
            ...updatedScenarioEstimations,
          },
        };

        let rowValueUpdate;

        if (groupBy) {
          const groupedValues = _.groupBy(
            EstimationsUpdated.estimations,
            (estimation) => {
              const key = `${estimation.product_id}${
                row.area ? "-".concat(estimation.area_id) : ""
              }${row.retailer ? "-".concat(estimation.retailer_id) : ""}${
                row.retailer_group
                  ? "-".concat(estimation.retailer.retailer_group_id)
                  : ""
              }`;
              return key;
            }
          );

          rowValueUpdate = groupEstimationsDaily(
            groupedValues,
            metadataSlice["custom-projection"],
            scenariosSlice.referenceScenario.estimations,
            configCatSlice?.features.newInvestmentCalculation
          )[keyToUpdate];
        } else rowValueUpdate = EstimationsUpdated.estimations[keyToUpdate];

        // setTupleRatio({
        //   units: rowValueUpdate.units - rowValueUpdateWithoutAjust.units,
        //   margin: rowValueUpdate.margin - rowValueUpdateWithoutAjust.margin,
        //   sales: rowValueUpdate.sales - rowValueUpdateWithoutAjust.sales,
        // });

        setRowHasTypeEvent(currentPromotionalEvent);

        setRowValues({
          ...rowValues,
          price: rowValueUpdate.price,
          price_in: rowValueUpdate.price_in,
          price_in_wo_taxes: rowValueUpdate.price_in_wo_taxes,
          price_out_wo_taxes: rowValueUpdate.price_out_wo_taxes,
          units: rowValueUpdate.units,
          units_in: rowValueUpdate.units_in,
          sales: rowValueUpdate.sales,
          sales_in: rowValueUpdate.sales_in,
          margin: rowValueUpdate.margin,
          investment: rowValueUpdate.investment,
          investment_in: rowValueUpdate.investment_in,
          roi: getROI(
            parseInt(rowValueUpdate.margin.toFixed(0), 10),
            referenceRow.margin,
            parseInt(
              (
                (referenceRow.price_in - rowValueUpdate.price_in) *
                rowValueUpdate.units_in
              ).toFixed(0),
              10
            ),
            {
              strategy: configCatSlice?.features.roiStrategy,
              unitsEsc: rowValueUpdate.units,
              unitsRef: referenceRow.units,
            }
          ),
        });
        // We update the scenario estimations
        const newTotals = {
          [scenariosSlice.selectedScenario.scenario.id]: {
            ...scenariosSlice.selectedScenario,
            ...computeEstimationTotals(
              {
                ...scenariosSlice.selectedScenario.estimations,
                ...updatedScenarioEstimations,
              },
              scenariosSlice.referenceScenario.estimations,
              configCatSlice?.features.newInvestmentCalculation,
              configCatSlice?.features.roiStrategy
            ),
          },
        };
        dispatch(addScenarioTotals(newTotals));
        dispatch(setSelectedScenario(EstimationsUpdated));

        dispatch(
          setCacheScenario({
            [handleScenarioType(
              scenariosSlice.selectedScenario.scenario.cycle.cycle_type_id
            )]: {
              ...scenariosSlice.selectedScenario,
              ...EstimationsUpdated,
            },
          })
        );

        if (
          scenariosSlice.selectedScenario.scenario.id ===
          scenariosSlice.referenceScenario.scenario.id
        ) {
          const EstimationsReferenceUpdated = {
            estimations: {
              ...scenariosSlice.referenceScenario.estimations,
              ...updatedScenarioEstimations,
            },
          };
          dispatch(setReferenceScenario(EstimationsReferenceUpdated));
          dispatch(
            setCacheReferenceScenario({
              [handleScenarioType(
                scenariosSlice.referenceScenario.scenario.cycle.cycle_type_id
              )]: {
                ...scenariosSlice.referenceScenario,
                ...EstimationsReferenceUpdated,
              },
            })
          );
        }
        dispatch(
          setScenarioEstimations({
            id: scenariosSlice.selectedScenario.scenario.id,
            estimations: {
              ...scenariosSlice.selectedScenario.estimations,
              ...updatedScenarioEstimations,
            },
          })
        );

        // Finally we request the server to update the scenario estimations in the database
        const config = {
          method: "PATCH",
          url: `${REACT_APP_BASE_URL}/scenario_estimations_daily`,
          data: _.map(
            scenarioEstimationInEstimationDaily,
            (dailyEstimation) => {
              return filterDailyEstimationFieldsWithoutIdentifier(
                dailyEstimation,
                scenariosSlice.selectedScenario.scenario.id
              );
            }
          ),
        };
        await athenaClient(config);
      }
    } catch (error) {
      setIsBadRequest(true);
    } finally {
      await setIsLoading(false);
      setIsPriceChange(false);
    }
  }, [isPriceChange]);

  const comprobeInvestmentPositive = (rowToComprobe, referenceRowPrice) => {
    const newRow = {
      ...rowToComprobe,
      investment_in: 0,
    };

    if (rowToComprobe.price >= referenceRowPrice && !groupBy) {
      setRowValues(newRow);
    } else {
      setRowValues(rowToComprobe);
    }
  };

  useMemo(() => {
    comprobeInvestmentPositive(row, referenceRow.price);
  }, [row]);

  const handleOnRowClick = async () => {
    // Evaluate if there is cannibalization to the scenario
    if (isBlocked) return;
    if (index === expandedRow) {
      setExpandedRow(-1);
    } else if (!isLoading) {
      try {
        setCurrentPromotionalEvent(DEFAULT_PROMOTIONAL_EVENT);
        setCurrentTupleData(null);
        /* MIXPANEL TRACKS */
        mixpanelTrack("Expand estimation row", {
          ...(row.product && { product: row.product.label }),
          ...(row.retailer && { retailer: row.retailer.label }),
          ...(row.area && { area: row.area.label }),
          cycle: scenariosSlice.selectedScenario.scenario.cycle.label,
        });
        /* END OF MIXPANEL TRACKS */

        setSelectedIndex(index);
        setExpandedRow(index);

        const tupleRequestParams = {
          filters: {
            product: row.product,
            ...(row.retailer && { retailer: row.retailer }),
            ...(row.retailer_group && { retailer_group: row.retailer_group }),
            ...(row.area && { area: row.area }),
            cycle: { id: scenariosSlice.selectedScenario.scenario.cycle_id },
            data_source_id: 1,
          },
        };

        const tupleDailyRequestParams = {
          filters: {
            product: row.product,
            ...(row.retailer && { retailer: row.retailer }),
            ...(row.retailer_group && { retailer_group: row.retailer_group }),
            ...(row.area && { area: row.area }),
            scenario_id: scenariosSlice.selectedScenario.scenario.id,
          },
        };

        const estimationsDailyUrl = buildRequestUrl(
          {
            ...tupleDailyRequestParams,
          },
          "scenario_estimations_daily"
        );

        const estimationsDailyConfig = {
          method: "GET",
          url: estimationsDailyUrl,
        };

        const estimationsUrl = buildRequestUrl(
          {
            ...tupleRequestParams,
            group_by: ["price"],
            sum: ["units", "margin", "units_in", "sales"],
            avg_weight_by_units_in: ["price_in", "price_in_wo_taxes"],
            avg_weight_by_units: ["price_out_wo_taxes"],
          },
          "estimations_by_cycle"
        );

        const deltaEventsByEstimationUrl = buildRequestUrl(
          {
            ...tupleRequestParams,
            count: "estimation_cycle_id",
            expand: "delta_events_by_cycle",
            group_by: "event_id",
            avg: ["slope", "intercept"],
          },
          "estimations_by_cycle"
        );

        const estimationsConfig = {
          method: "GET",
          url: estimationsUrl,
        };

        const deltaEventsByEstimationConfig = {
          method: "GET",
          url: deltaEventsByEstimationUrl,
        };

        setOwnElasticity(
          _.round(
            (
              await getElasticities({
                product_id: row.product_id,
                source_product_id: row.product_id,
                data_source_id: 1,
                is_product_client: 1,
                ...(row.retailer && { retailer_id: row.retailer_id }),
                ...(row.retailer_group && {
                  retailer_group_id: row.retailer_group.id,
                }),
                ...(row.area && { area_id: row.area_id }),
                avg_weight_by_pred_units_last_price: ["elasticity"],
                group_by: "product_id",
                filter_type: "same",
                min_date:
                  scenariosSlice.selectedScenario.scenario.cycle.initial_date,
                max_date:
                  scenariosSlice.selectedScenario.scenario.cycle.final_date,
              })
            ).data[0]?.avg_weight_by_pred_units_last_price_elasticity,
            2
          )
        );

        const [
          deltaEventsByEstimationResponse,
          estimationsResponse,
          estimationDailyResponse,
        ] = await Promise.all([
          athenaClient(deltaEventsByEstimationConfig),
          athenaClient(estimationsConfig),
          athenaClient(estimationsDailyConfig),
        ]);
        setScenarioEstimationsDaily(estimationDailyResponse);

        const deltaEvents = [];
        _.forEach(deltaEventsByEstimationResponse.data, (deltaEvent) => {
          if (deltaEvent.count_estimation_cycle_id > 0) {
            deltaEvents.push(deltaEvent.event_id);
            setMultibuySlopeIntercept({
              avg_slope: deltaEvent.avg_slope,
              avg_intercept: deltaEvent.avg_intercept,
            });
          }
        });
        setCurrentDeltaEvents(deltaEvents);
        const initialRowEvenType = _.find(
          estimationDailyResponse.data,
          (estimation) => {
            return estimation.event_id !== null;
          }
        );

        const matchedRowEventType = _.find(deltaEventsCatalog, {
          id: initialRowEvenType?.event_id,
        });

        setRowHasTypeEvent({
          key: matchedRowEventType ? matchedRowEventType.id : null,
          label: matchedRowEventType ? matchedRowEventType.label : "TPR",
        });

        setCurrentTupleData({
          estimations: groupByPriceAndReduceEstimations(
            estimationsResponse.data.map((obj) => {
              // Destructure the object to extract the old key value
              const {
                avg_weight_by_units_in_price_in,
                avg_weight_by_units_price_out_wo_taxes,
                avg_weight_by_units_in_price_in_wo_taxes,
                ...rest
              } = obj;
              // Create a new object with the renamed key and the rest of the properties
              return {
                price_in: avg_weight_by_units_in_price_in,
                price_out_wo_taxes: avg_weight_by_units_price_out_wo_taxes,
                price_in_wo_taxes: avg_weight_by_units_in_price_in_wo_taxes,
                ...rest,
              };
            }),
            metadataSlice["custom-projection"],
            "sum_"
          ),
        });
      } catch (error) {
        setIsBadRequest(true);
      }
    }
  };

  const SelectEventTypeComponent = () => {
    if (isReference) return null;
    if (
      (currentDeltaEvents.length > 0 &&
        Number(multibuySlopeIntercept.avg_slope) > 0) ||
      Number(multibuySlopeIntercept.avg_intercept) > 0
    ) {
      const selectOptions = [DEFAULT_PROMOTIONAL_EVENT];
      _.map(currentDeltaEvents, (deltaEventId) => {
        const deltaEventCatalog = deltaEventsCatalog[String(deltaEventId)];
        if (deltaEventCatalog && deltaEventId === deltaEventCatalog.id) {
          let eventLabel = deltaEventCatalog.label;

          if (deltaEventId === 1) {
            eventLabel = (
              <div className={`${classes.multibuyTextWithIcon}`}>
                {eventLabel}&ensp;
                <RiMastercardLine className={`${classes.icon}`} />
              </div>
            );
          }

          selectOptions.push({
            key: deltaEventCatalog.id,
            label: deltaEventCatalog.label,
            labelWithIcon: eventLabel,
          });
        }
      });

      return (
        <div className={classes.containerSelectOptionsDailyPromotions}>
          <div className={classes.selectContainerEventType}>
            <SelectOptionsComponent
              selectValue={currentPromotionalEvent}
              setSelectValue={(value) => {
                if (value.label === "Multibuy")
                  mixpanelTrack(`Select Multibuy as promotional event`);
                setCurrentPromotionalEvent(value);
              }}
              selectTitle="Promotional event"
              selectOptions={selectOptions}
              setCurrentTupleData={setCurrentTupleData}
              currentTupleData={currentTupleData}
              metadataSlice={metadataSlice}
              row={row}
              cycleId={scenariosSlice.selectedScenario.scenario.cycle_id}
            />
          </div>
        </div>
      );
    }
    return <div className={classes.containerSelectOptionsDailyPromotions} />;
  };

  return (
    <div style={style}>
      <BadRequestDialog open={isBadRequest} />
      <div
        role="presentation"
        onClick={() => handleOnRowClick()}
        className={`${classes.row} ${index % 2 && classes.darkGreyBackground} ${
          rowValues.price === referenceRow.price && !isReference && !groupBy
            ? classes.light
            : null
        }`}
        style={{ cursor: isBlocked ? "default" : "pointer" }}
      >
        <div className={classes.rowCell}>
          <IconButton
            aria-label="expand row"
            size="small"
            classes={{
              root: classes.expandButton,
            }}
            disableRipple
            style={{ cursor: isBlocked ? "default" : "pointer" }}
          >
            {isBlocked ? (
              <LockIcon fontSize="small" />
            ) : index === expandedRow ? (
              <KeyboardArrowUpIcon />
            ) : (
              <KeyboardArrowDownIcon />
            )}
          </IconButton>
        </div>
        {_.map(labelTableColumns, (columnName) => {
          if (groupBy && ["retailer", "area"].includes(columnName)) return null;
          return (
            <div
              className={`${classes.rowCell} ${classes.large}`}
              key={columnName}
            >
              <Tooltip
                title={rowValues[columnName].label}
                placement="top-start"
              >
                <Typography variant="body2" className={classes.cellValue}>
                  {rowValues[columnName].label}
                </Typography>
              </Tooltip>
            </div>
          );
        })}

        {_.map(numericTableColumns, (columnName) => {
          if (isReference && columnName === "investment_in") return null;

          const isInvestmentOrROI = columnName === "units_in" && isTpo;

          let refPriceIn = referenceRow.price_in;
          let estPriceIn = rowValues.price_in;
          if (configCatSlice?.features.newInvestmentCalculation) {
            refPriceIn = referenceRow.price_in_wo_taxes;
            estPriceIn = rowValues.price_in_wo_taxes;
          }

          const investmentInCalculation = parseInt(
            ((refPriceIn - estPriceIn) * rowValues.units_in).toFixed(0),
            10
          );
          const investmentOrROI = isInvestmentOrROI
            ? rowValues.price < referenceRow.price
              ? getROI(
                  parseInt(rowValues.margin.toFixed(0), 10),
                  referenceRow.margin,
                  investmentInCalculation,
                  {
                    strategy: configCatSlice?.features.roiStrategy,
                    unitsEsc: rowValues.units,
                    unitsRef: referenceRow.units,
                  }
                )
              : "N/A"
            : columnName === "investment_in"
            ? nFormatter(investmentInCalculation)
            : nFormatter(rowValues[columnName]);

          const tableBodyPercentageInvestmentOrROI = isInvestmentOrROI
            ? null
            : rowValues[columnName] !== null &&
              `${Math.abs(
                (100 * (rowValues[columnName] - referenceRow[columnName])) /
                  referenceRow[columnName]
              ).toFixed(2)}%`;

          return (
            metadataSlice["custom-projection"][columnName][0]
              .visibility_type === 2 && (
              <div
                key={columnName}
                className={`${classes.rowCell} ${classes.numeric}`}
              >
                <Tooltip
                  title={getFormattedCellValue(columnName, investmentOrROI)}
                  placement="top-start"
                >
                  {!groupBy ? (
                    <Typography variant="body2" className={classes.cellValue}>
                      {columnName !== "investment_in"
                        ? getFormattedCellValue(columnName, investmentOrROI)
                        : (refPriceIn - estPriceIn) * rowValues.units_in > 0
                        ? nFormatter(
                            (refPriceIn - estPriceIn) * rowValues.units_in
                          )
                        : 0}
                    </Typography>
                  ) : (
                    <Typography variant="body2" className={classes.cellValue}>
                      {getFormattedCellValue(columnName, investmentOrROI)}
                    </Typography>
                  )}
                </Tooltip>
                {tableBodyPercentageInvestmentOrROI?.toString() !== "0.00%" &&
                  rowValues[columnName] !== null &&
                  rowValues[columnName] - referenceRow[columnName] !== 0 &&
                  columnName !== "investment_in" &&
                  !isReference && (
                    <Typography
                      variant="body2"
                      className={`${classes.cellPercentage}`}
                    >
                      {(!isTpo || columnName !== "units_in") && (
                        <BsArrowUp
                          size={13}
                          strokeWidth={1.5}
                          style={{
                            marginRight: "5px",
                            color: `${
                              columnName === "price"
                                ? "#a2a2a2"
                                : (100 *
                                    (rowValues[columnName] -
                                      referenceRow[columnName])) /
                                    referenceRow[columnName] >
                                  0
                                ? "#5AB793"
                                : "#FD6464"
                            }`,
                            transform: `rotateX(${
                              (100 *
                                (rowValues[columnName] -
                                  referenceRow[columnName])) /
                                referenceRow[columnName] >
                              0
                                ? "0deg"
                                : "180deg"
                            })`,
                          }}
                        />
                      )}
                      {tableBodyPercentageInvestmentOrROI}
                    </Typography>
                  )}
              </div>
            )
          );
        })}
        {isTpo &&
          isReference &&
          metadataSlice["custom-projection"].investment_in[0]
            .visibility_type === 2 && (
            <div
              key="investment_in"
              className={`${classes.rowCell} ${classes.numeric}`}
            >
              <Tooltip
                title={getFormattedCellValue(
                  "investment_in",
                  configCatSlice?.features.newInvestmentCalculation
                    ? (referenceRow.price_in_wo_taxes -
                        rowValues.price_in_wo_taxes) *
                        rowValues.units_in
                    : (referenceRow.price_in - rowValues.price_in) *
                        rowValues.units_in
                )}
                placement="top-start"
              >
                <Typography variant="body2" className={classes.cellValue}>
                  {nFormatter(0)}
                </Typography>
              </Tooltip>
            </div>
          )}
      </div>
      <Collapse in={index === expandedRow} timeout={0} unmountOnExit>
        <CardComponent
          title={
            dailyPromotion ? (
              <>
                <div
                  className={`${classes.titleHeader} ${classes.dailyCardTitleAnimation}`}
                >
                  <div className={classes.CalendarCardContainerDailyPromotions}>
                    <StyledTooltip
                      title={textTitle("Back to cycle promotions")}
                      placement="right"
                    >
                      <StylePromotiondButton
                        disableRipple
                        onClick={() => handleDailyPromotions()}
                        className={classes.promotionButtonActive}
                      >
                        <RiCalendar2Line
                          className={`${classes.icon} ${classes.iconDailyPromotions}`}
                        />
                      </StylePromotiondButton>
                    </StyledTooltip>
                  </div>
                  <div
                    className={`${classes.headerFirstTextDailyPromotions} ${classes.titleOffsetAnimation}`}
                  >
                    {rowHasTypeEvent.key !== null ? (
                      <StyledTooltip
                        title={textTitle(
                          "Multibuy promotion has been",
                          "selected for some/all days",
                          "and lower aggregation levels"
                        )}
                        placement="left"
                      >
                        <StyledButton disableRipple>
                          <RiMastercardLine
                            className={`${classes.icon} ${classes.iconMultibuy}`}
                          />
                        </StyledButton>
                      </StyledTooltip>
                    ) : null}
                    <Typography variant="h6" className={classes.titleCard}>
                      Daily Price Simulator -
                    </Typography>
                    <div className={classes.textContainerDailyPromotions}>
                      <Typography className={classes.textOwnElasticity}>
                        Own Elasticity:
                      </Typography>
                      <Typography
                        style={{
                          paddingLeft: "5px",
                        }}
                        s
                        className={classes.textOwnElasticity}
                      >
                        {ownElasticity}
                      </Typography>
                    </div>
                  </div>
                  <SelectEventTypeComponent />
                </div>
                <div className={classes.calendarContainerDailyPromotions}>
                  <DailyPromotionsComponent
                    setIsSelectedDays={setIsSelectedDays}
                    isSelectedDays={isSelectedDays}
                    scenarioEstimationsDaily={scenarioEstimationsDaily}
                    setDailySelectedEstimations={setDailySelectedEstimations}
                    setDailyTotalWeight={setDailyTotalWeight}
                    setCalendarDays={setCalendarDays}
                    setIsSelectedSameDays={setIsSelectedSameDays}
                    deltaEventsCatalog={deltaEventsCatalog}
                  />
                </div>
              </>
            ) : (
              <div
                className={`${classes.titleHeader} ${classes.cardTitleAnimation}`}
              >
                <div className={classes.CalendarCardContainerDailyPromotions}>
                  <StyledTooltip
                    title={
                      scenarioEstimationsDaily?.data
                        ? textTitle("Custom daily promotions")
                        : textTitle("Disabled waiting for data")
                    }
                    placement="right"
                  >
                    <StylePromotiondButton
                      disableRipple
                      onClick={() => handleTpo()}
                    >
                      <RiCalendar2Line
                        className={`${classes.icon} ${classes.iconDailyPromotions}`}
                      />
                    </StylePromotiondButton>
                  </StyledTooltip>
                </div>
                <div
                  className={`${classes.headerFirstTextDailyPromotions} ${classes.titleOffsetReverseAnimation}`}
                >
                  {rowHasTypeEvent.key !== null ? (
                    <StyledTooltip
                      title={textTitle(
                        "Multibuy promotion has been",
                        "selected for some/all days",
                        "and lower aggregation levels"
                      )}
                      placement="left"
                    >
                      <StyledButton disableRipple>
                        <RiMastercardLine
                          className={`${classes.icon} ${classes.iconMultibuy}`}
                        />
                      </StyledButton>
                    </StyledTooltip>
                  ) : null}
                  <Typography variant="h6" className={classes.titleCard}>
                    Price Simulator -
                  </Typography>
                  <div className={classes.textContainerDailyPromotions}>
                    <Typography className={classes.textOwnElasticity}>
                      Own Elasticity:
                    </Typography>
                    <Typography
                      style={{
                        paddingLeft: "5px",
                      }}
                      s
                      className={classes.textOwnElasticity}
                    >
                      {ownElasticity}
                    </Typography>
                  </div>
                </div>
                <SelectEventTypeComponent />
              </div>
            )
          }
          body={
            <div style={{ paddingBottom: 0, paddingTop: 0 }}>
              {dailyPromotion && isSelectedDays ? (
                <div className={classes.borderBarTop} />
              ) : null}
              <Box className={classes.expansionDetailsContainer}>
                {/* Show this chart when selecting specific days for daily promotions */}
                {dailyPromotion && isSelectedDays && isSelectedSameDays ? (
                  <EstimationDailyPromotionsChartComponent
                    isReference={isReference}
                    selectedRowByCycle={rowValues}
                    referenceRow={referenceRow}
                    groupBy={groupBy}
                    setSelectedPrice={setSelectedPrice}
                    setIsPriceChange={setIsPriceChange}
                    selectedPriceState={selectedPrice}
                    tupleEstimationsByCycle={currentTupleData?.estimations}
                    // This object is the difference between units/margin/sales cannibalizations and without cannibalizations
                    // tupleAdjustments={tupleRatio}
                    estimationsDaily={scenarioEstimationsDaily.data}
                    dailySelectedEstimations={dailySelectedEstimations}
                    dailyTotalWeight={dailyTotalWeight}
                    currentPromotionalEvent={currentPromotionalEvent}
                    eventLabelHoverChart={eventLabelHoverChart}
                  />
                ) : dailyPromotion ? (
                  // Show this if there is not specific days selected for daily promotions, but the calendar is open
                  <InitialChartDailyPromotionsComponent />
                ) : currentTupleData ? (
                  <div className={classes.itemContainer}>
                    {/* Show this chart if there is no specific days selected for daily promotions, and the calendar is not open */}
                    <EstimationCyclePromotionsChartComponent
                      isReference={isReference}
                      selectedRowByCycle={rowValues}
                      referenceRow={referenceRow}
                      groupBy={groupBy}
                      setSelectedPrice={setSelectedPrice}
                      selectedPriceState={selectedPrice}
                      setIsPriceChange={setIsPriceChange}
                      eventLabelHoverChart={eventLabelHoverChart}
                      tupleEstimationsByCycle={currentTupleData?.estimations}
                      // This object is the difference between units/margin/sales cannibalizations and without cannibalizations
                      // tupleAdjustments={tupleRatio}
                      currentPromotionalEvent={currentPromotionalEvent}
                    />
                  </div>
                ) : (
                  <ScaleLoader size={150} color={primaryColor} loading />
                )}
              </Box>
              {!dailyPromotion || (dailyPromotion && isSelectedDays) ? (
                <Typography variant="body1" className={classes.textSlider}>
                  {priceOutLabelByTenant} (
                  {metadataSlice["custom-projection"].price[0].unit})
                </Typography>
              ) : null}
            </div>
          }
          estimationCardContainer
          isDailyPromotions
        />
      </Collapse>
    </div>
  );
}
